import React from "react";


const VesselSVGMarkup = ({ color, iconDirection, handleOnMarkerClick, isMarkerChecked }) => {

	let style = {
		position: "absolute",
		cursor: "pointer",
	};

	if (iconDirection) {
		style = {
			...style,
			// transform: `translate(-50%, -50%) rotate(${iconDirection}deg)`,
		};
	};

	return (
		<div
			className={`vesselSVGIcon`}
			style={isMarkerChecked ? { backgroundColor: "#F4F7FE" } : null}
			onClick={handleOnMarkerClick}
		>
			<svg className="svg-icons" width="27" height="27" viewBox="0 0 27 27" fill={color} xmlns="http://www.w3.org/2000/svg">
				<g clipPath="url(#clip0_567_269)">
					<path d="M13.5001 14.14C15.1715 14.14 16.5265 12.7861 16.5265 11.1159C16.5265 9.44574 15.1715 8.0918 13.5001 8.0918C11.8286 8.0918 10.4736 9.44574 10.4736 11.1159C10.4736 12.7861 11.8286 14.14 13.5001 14.14Z" fill={color} />
					<path d="M21.4826 3.30381C19.3506 1.17334 16.5156 4.5106e-07 13.5002 3.55972e-07C10.4854 2.60901e-07 7.65041 1.17334 5.51836 3.30381C3.38631 5.43428 2.21191 8.26664 2.21191 11.2794C2.21191 13.3877 2.79674 15.5218 3.94951 17.6233C4.85654 19.276 6.11584 20.9118 7.6926 22.4859C10.3578 25.1459 12.9898 26.7005 13.1005 26.7653L13.5002 27L13.9005 26.7653C14.0112 26.7005 16.6427 25.1459 19.3079 22.4859C20.8846 20.9118 22.1445 19.276 23.051 17.6233C24.2043 15.5218 24.7886 13.3877 24.7886 11.2794C24.7886 8.26664 23.6147 5.43428 21.4826 3.30381ZM13.5002 15.7212C10.959 15.7212 8.89178 13.655 8.89178 11.1159C8.89178 8.57672 10.959 6.51111 13.5002 6.51111C16.0415 6.51111 18.1087 8.57672 18.1087 11.1159C18.1087 13.655 16.0415 15.7212 13.5002 15.7212Z" fill={color} />
				</g>
				<defs>
					<clipPath id="clip0_567_269">
						<rect width="27" height="27" fill="white" />
					</clipPath>
				</defs>
			</svg>
		</div>
	);
};

export default VesselSVGMarkup;
